<template>
	<div class="wrap">
		<Title :title="vacationName"></Title>
		<div class="export-wrap">
			<el-button type="primary" size="mini" @click="addMessage">添加</el-button>
		</div>
		<el-table border size="mini" :data="dataList" style="width: 100%">
			<el-table-column type="selection" width="55">
			</el-table-column>
			<el-table-column prop="title" label="标题">
			</el-table-column>
			<el-table-column prop="title" label="消息内容">
				<template slot-scope="scope">
					<div class="message-content" v-html="scope.row.content"></div>
				</template>
			</el-table-column>
			<el-table-column prop="noticeScope" label="通知范围">
				<template slot-scope="scope">
					<span v-if="scope.row.noticeScope==0">所有人</span>
					<span v-if="scope.row.noticeScope==1">入选人员</span>
				</template>
			</el-table-column>
			<el-table-column prop="title" label="发布时间">
				<template slot-scope="scope">
					{{scope.row.addTime | datefmt2('YYYY-MM-DD HH:mm:ss')}}
				</template>
			</el-table-column>
			<el-table-column prop="title" label="发布状态">
				<template slot-scope="scope">
					<el-switch 
					@click.native.prevent="changePublic(scope.row)" 
					v-model="scope.row.status"
					disabled
					active-color="#13ce66"
					inactive-color="#ff4949">
					</el-switch>
				</template>
			</el-table-column>
			<el-table-column label="操作">
				<template slot-scope="scope">
					<div class="manage-btns">
						<span @click="addMessage(scope.row)">修改</span>
						<span class="space"> | </span>
						<span @click="deleteMessage(scope.row)">删除</span>
					</div>
				</template>
			</el-table-column>
		</el-table>
		<!-- <div class="export-wrap">
			<el-button type="primary" size="mini">批量删除</el-button>
		</div> -->
		<Pagination :total="total" :pageSize="pageSize" @pageChange="handleCurrentChange"/>
		<!--公告弹窗-->
		<el-dialog title="添加公告消息" :visible.sync="detailDialog" width="50%" @close="handleClose()">
			<el-form :inline="true" :model="formInfo" :rules="rules" ref="messageForm" class="add-dialog">
				<el-form-item label="公告标题" prop="title">
					<el-input v-model="formInfo.title" placeholder="请输入公告标题" clearable></el-input>
				</el-form-item>
				<el-form-item label="公告内容" prop="content">
					<div class="editor-wrap">
						<quill-editor class="editor" v-model="formInfo.content" ref="myQuillEditor" :options="editorOption"/>
					</div>
					<!-- <el-input :rows="6" type="textarea" clearable placeholder="请输入活动介绍"
						v-model="formInfo.content"></el-input> -->
				</el-form-item>
				<el-form-item style="margin-top: -10px;" label="通知类型" prop="noticeScope">
					<el-radio-group v-model="formInfo.noticeScope">
						<el-radio label="0">所有人</el-radio>
						<el-radio label="1">入选人员</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item style="margin-top: -25px;" label="发布状态" prop="status">
					<el-radio-group v-model="formInfo.status">
						<el-radio label="0">未发布</el-radio>
						<el-radio label="1">已发布</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item>
					<div class="flex-end">
						<el-button size="mini" type="primary" @click="toRset">重置</el-button>
						<el-button size="mini" type="primary" @click="toConfirm">提交</el-button>
					</div>
				</el-form-item>
			</el-form>
		</el-dialog>
		
	</div>
</template>

<script>
	import Title from '@/components/titleAdmin'
	import Pagination from '@/components/admin/pagination'
	import qs from 'qs'
	import { post,ajaxParam } from '@/units/request.js'
	import { quillEditor } from "vue-quill-editor"; //调用编辑器
	import 'quill/dist/quill.core.css';
	import 'quill/dist/quill.snow.css';
	import 'quill/dist/quill.bubble.css';
	import { Quill } from "vue-quill-editor"; 
	import { eeSourceBtn } from '@/units/quill.eeSourceBtn.js';
	// 注册我们写的事件
	Quill.register( 'modules/eeSourceBtn', eeSourceBtn );
	export default {
		name: 'MessageList',
		components: {
			Title,
			quillEditor,
			Pagination
		},
		data() {
			return {
				pageNum: 1,
				pageSize: 10,
				total: 0,
				dataList: [],
				vacationId: '',
				vacationName: '',
				activityType: '', //活动类型(0包裹发放,1最美推荐)
				detailDialog: false,
				editorOption: {
					placeholder: "请在这里输入",
					modules: {
						eeSourceBtn: eeSourceBtn,  // 引入我我们新增的事件
						toolbar: {
							container: [
								['bold', 'strike'],    //加粗，斜体，下划线，删除线
								[{ 'script': 'sub' }, { 'script': 'super' }],   // 上下标
							]
						}
					}
				},
				formInfo: {
					messageId: '',
					title: '', 
					content: '',
					noticeScope: '0',  //0所有人，1入选人员
					status: '1' //0未发布  1已发布
				},
				rules: {
					title: [{
						required: true,
						message: '请输入公告标题',
						trigger: 'blur'
					}],
					content: [{
						required: true,
						message: '请输入活动介绍',
						trigger: 'blur'
					}]
				}
			}
		},
		created(){
			this.vacationId = this.$route.query.id||''
			this.getDataList()
		},
		methods: {
			//获取消息列表
			async getDataList() {
				let param = {
					vacationId: this.vacationId,
					activityType: this.activityType,
					pageNum: this.pageNum,
					pageSize: this.pageSize
				}
				ajaxParam(param)
				const res = await post('admin/notice/list', qs.stringify(param))
				if (res.data.code == 200) {
					let datalist = res.data.page.items
					datalist.forEach(item => {
						item.status = item.status == '1' ? true : false
					})
					this.dataList = datalist
					this.total = res.data.page.count
					this.vacationName = res.data.vacationName
					this.vacationId = res.data.vacationId
				}
			},
			//分页
			handleCurrentChange(e){
				this.dataList = []
				this.pageNum = e.number
				this.getDataList()
			},
			//发布状态改变
			changePublic(row){
				let status = row.status?'取消发布':'发布'
				this.$confirm('确定要'+status+'吗？', '温馨提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(async () => {
					let param = {
						id: row.id,
						status: row.status?'0':'1'
					}
					ajaxParam(param)
					const res = await post('admin/notice/updateStatus', qs.stringify(param))
					if (res.data.code == 200) {
						console.log(res.data)
						this.dataList.forEach(item=>{
							if(item.id==row.id){
								item.status = item.status?false:true
							}
						})
					}
				}).catch(() => {
				
				})
			},
			//删除消息
			deleteMessage(row){
				this.$confirm('确定要删除消息吗？', '温馨提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(async () => {
					let param = {
						id: row.id
					}
					ajaxParam(param)
					const res = await post('admin/notice/delete', qs.stringify(param))
					if (res.data.code == 200) {
						this.$message.success('删除成功！')
						this.dataList.forEach((item,index)=>{
							if(item.id==row.id){
								this.dataList.splice(index,1)
							}
						})
					}
				}).catch(() => {
							
				})
			},
			//添加消息
			addMessage(row){
				this.detailDialog = true
				//问题：这里row传过来的status竟然是true,转换了一下
				if(row.id){
					this.formInfo.messageId = row.id
					this.formInfo.title = row.title
					this.formInfo.content = row.content
					this.formInfo.status = row.status?'1':'0'
					this.formInfo.noticeScope = row.noticeScope
				}
			},
			//提交
			toConfirm(){
				this.$refs.messageForm.validate( async valid =>{
					if(valid){
						let param = {
							id: this.formInfo.messageId||'',
							noticeType: 1, //0平台   1活动类型 
							vacationId: this.vacationId,
							title: this.formInfo.title,
							content: this.formInfo.content,
							noticeScope: this.formInfo.noticeScope,
							status: this.formInfo.status
						}
						ajaxParam(param)
						const res = await post('admin/notice/save', qs.stringify(param))
						if (res.data.code == 200) {
							this.$message.success('提交成功！')
							this.detailDialog = false
							this.getDataList()
						}
					}
				})
			},
			//关闭消息详情弹框
			handleClose(){
				this.detailDialog = false
				this.formInfo.messageId = ''
				this.formInfo.title = ''
				this.formInfo.content = ''
			},
			//重置详情弹窗
			toRset(){
				this.formInfo.title = ''
				this.formInfo.content = ''
			}
		}
	}
</script>

<style scoped lang="less">
	.wrap {
		background: #fff;
		border: 1px solid #e4e4e4;
		border-radius: 4px;
		margin-bottom: 10px;
		padding: 15px;
	}
	.message-content{
		height: 26px;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap
	}
	.export-wrap{
		display: flex;
		padding: 10px 0 15px;
	}
	.flex-end{
		display: flex;
		justify-content: flex-end;
		
	}
	.manage-btns{
		color: #EB6B1B;
		span{
			cursor: pointer;
		}
		.space{
			margin: 0 5px;
			cursor: default;
		}
	}
	/deep/ .el-button--primary {
		background: #EB6B1B;
		border-color: #EB6B1B;
	}
	
	/deep/ .el-button--mini,
	.el-button--mini.is-round {
		padding: 4px 15px;
	}
	
	/deep/ .el-button {
		font-size: 12px !important;
	}
	/deep/ .el-switch.is-disabled {
	 opacity: 1;
	}
	/deep/ .el-switch.is-disabled .el-switch__core, /deep/ .el-switch.is-disabled .el-switch__label {
	  cursor: pointer !important;;
	}
	/deep/ .el-dialog__header {
		padding-top: 15px;
		padding-bottom: 15px;
		border-bottom: 1px solid #DBDCDC !important;
	}
	/deep/ .el-dialog__body {
		padding-top: 10px;
	}
	.el-dialog__wrapper /deep/ .el-form--inline .el-form-item{
		width: 100%;
		display: flex;
	}
	.el-dialog__wrapper /deep/ .el-form-item__content{
		flex: 1
	}
	.editor-wrap {
		margin-bottom: 60px;
		.editor{
			height: 150px;
		}
	}
	/deep/ .ql-snow.ql-toolbar button{
		width: auto
	}
	/deep/ .ql-toolbar.ql-snow{
		padding: 0 8px;
	}
</style>